import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { SuggestionRow } from "./SuggestionRow";
import { LANG_NAMES, errMsg } from "./useAuthedHttp";

const pill = (on) => `rounded-full px-3.5 py-1.5 text-sm border transition-colors ${on ? "bg-[#1C242B] text-white border-[#1C242B]" : "border-[#1C242B]/15 hover:bg-[#1C242B]/5"}`;

export const ReviewQueue = ({ call, langs }) => {
  const [status, setStatus] = useState("pending");
  const [lang, setLang] = useState("all");
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    call("get", `/translations/suggestions?status=${status}`)
      .then((d) => setItems(d.suggestions))
      .catch((e) => { toast.error(errMsg(e, "Could not load suggestions")); setItems([]); });
  }, [call, status]);

  const shown = (items || []).filter((s) => lang === "all" || s.lang === lang);
  return (
    <section data-testid="review-queue">
      <div className="flex flex-wrap gap-2">
        {["pending", "accepted", "rejected"].map((s) => (
          <button key={s} onClick={() => setStatus(s)} data-testid={`review-status-${s}`} className={pill(status === s)}>{s[0].toUpperCase() + s.slice(1)}</button>
        ))}
        <select value={lang} onChange={(e) => setLang(e.target.value)} data-testid="review-lang-filter"
          className="ml-auto rounded-full border border-[#1C242B]/15 bg-white px-3 py-1.5 text-sm">
          <option value="all">All my languages</option>
          {langs.map((l) => <option key={l} value={l}>{LANG_NAMES[l] || l}</option>)}
        </select>
      </div>
      {items === null ? <Loader2 className="mt-8 animate-spin text-slate-400" /> : shown.length === 0 ? (
        <p className="mt-8 text-slate-500" data-testid="review-admin-empty">No {status} suggestions.</p>
      ) : (
        <ul className="mt-6 grid gap-4">
          {shown.map((s) => <SuggestionRow key={s.id} s={s} call={call} readOnly={status !== "pending"} onDone={(id) => setItems(items.filter((x) => x.id !== id))} />)}
        </ul>
      )}
    </section>
  );
};
